import { Ticket, Star } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../../components/Reveal";
import { Eyebrow } from "../../components/Bits";
import { LINEUP, GRADS, TICKET_URL } from "./prideData";
import { LineupCard, RainbowBar, RainbowArc } from "./PrideParts";

export default function PrideLineup() {
  const headliners = LINEUP.filter((a) => a.headline);
  const rest = LINEUP.filter((a) => !a.headline);
  return (
    <div>
      <section className="relative overflow-hidden bg-nead-ink text-white">
        <RainbowArc className="-top-40 -right-32 h-[26rem] w-[26rem]" />
        <div className="relative container-x py-16 md:py-24">
          <Reveal>
            <Eyebrow className="text-nead-cyan">Main stage lineup</Eyebrow>
            <h1 className="mt-4 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight">Joining us in no particular order.</h1>
            <p className="mt-5 max-w-2xl text-white/65 text-lg leading-relaxed">
              A stacked bill of live music, pop and cabaret across the main arena. More acts to be announced. Main arena entry is just £3.99.
            </p>
          </Reveal>

          {/* Headliners */}
          <div className="mt-12 flex items-center gap-2 text-nead-pink">
            <Star className="h-5 w-5 fill-nead-pink" /><span className="font-display font-bold uppercase tracking-wider text-sm">Headliners</span>
          </div>
          <Stagger className="mt-5 grid sm:grid-cols-2 gap-5">
            {headliners.map((a) => (
              <StaggerItem key={a.name}>
                <div className="group relative aspect-[4/3] overflow-hidden rounded-[1.5rem] ring-2 ring-nead-pink" data-testid={`headliner-${a.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  <img src={a.photo} alt={a.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-nead-ink/90 via-nead-ink/20 to-transparent" />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-nead-pink px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-white shadow"><Star className="h-3.5 w-3.5 fill-white" /> Headliner</span>
                  <div className="absolute inset-x-0 bottom-0 p-6">
                    <h3 className="font-display font-bold text-3xl sm:text-4xl text-white tracking-tight">{a.name}</h3>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>

          {/* Rest of lineup */}
          <div className="mt-12 flex items-center gap-2 text-nead-cyan">
            <span className="font-display font-bold uppercase tracking-wider text-sm">Also appearing</span>
          </div>
          <Stagger className="mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {rest.map((a, i) => (
              <StaggerItem key={a.name}><LineupCard name={a.name} photo={a.photo} grad={GRADS[i % GRADS.length]} /></StaggerItem>
            ))}
          </Stagger>

          <div className="mt-12">
            <a href={TICKET_URL} target="_blank" rel="noreferrer" data-testid="lineup-tickets" className="inline-flex items-center gap-2 rounded-full bg-nead-pink px-6 py-3 text-sm font-semibold text-white hover:bg-white hover:text-nead-navy transition-colors">
              <Ticket className="h-4 w-4" /> Get main arena tickets, £3.99
            </a>
          </div>
        </div>
      </section>
      <RainbowBar />
    </div>
  );
}
